import {EntityBase} from "../../../shared/entity/EntityBase";

const TROPHY_CHALLENGE_MISSION_GROUP_FIELDS = {
    groupIdx: {type: Number, defaultValue: 0},
    memo: {defaultValue: ''},
    isFixed: {type: Number, defaultValue: 0},
}

export class TrophyChallengeMissionGroupEntity extends EntityBase {
    constructor(data = {}) {
        super(data, TROPHY_CHALLENGE_MISSION_GROUP_FIELDS);

        this.errors = [
            {condition: () => this.groupIdx <= 0, message: '그룹 번호를 입력해주세요.'},
        ];
    }
}
